import { Footer } from "apps/oneOnboarding/Footer";
import { ProfileFormFields } from "apps/oneOnboarding/profile/ProfileFormFields";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { useFooterNavigation } from "apps/oneOnboarding/useFooterNavigation";
import type { ProfileData, PropertyData } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { FormProvider, type UseFormReturn, useForm } from "react-hook-form";
import { useBulkProfileFormHandler } from "./useBulkProfileFormHandler";

interface Props {
    data: ProfileData;
    propertyForm?: UseFormReturn<PropertyData>;
}

export const BatchProfileForm: FunctionComponent<Props> = ({ data }) => {
    const {
        cmsData: {
            common: { back, next },
        },
    } = useStaticDataAtomValue();
    const form = useForm<ProfileData>({
        defaultValues: data,
        shouldFocusError: true,
    });
    const { mutate, isLoading } = useBulkProfileFormHandler();
    const { handleBack } = useFooterNavigation();

    const handleSubmit = (data: ProfileData) => {
        return mutate(data);
    };

    return (
        <FormProvider {...form}>
            <form id="bulk-profile-data-form" onSubmit={form.handleSubmit(handleSubmit)}>
                <ProfileFormFields />
                <Footer
                    secondary={{
                        label: back,
                        disabled: isLoading,
                        dataElementName: "bulk-onboarding-back",
                    }}
                    primary={{
                        type: "submit",
                        label: next,
                        disabled: isLoading,
                        loading: isLoading,
                        dataElementName: "bulk-onboarding-next",
                    }}
                    onSecondary={handleBack}
                />
            </form>
        </FormProvider>
    );
};
